// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"8311548d","450":"a2a36c5f"}[chunkId] + ".chunk.js";
};